// Valeurs saisies par les utilisateurs (noms, adresses…) : jamais traduites
export const DATA_VALUES = new Set();
const KEYS = new Set(["name", "first_name", "last_name", "city", "address", "site_name", "client_name", "agent_name", "company_name", "contact_name",
  "legal_name", "notes", "registry_name", "subcontractor_name", "requester_name"]);

export function registerData(v, depth = 0) {
  if (!v || depth > 6 || DATA_VALUES.size > 50000) return;
  if (Array.isArray(v)) { v.forEach((x) => registerData(x, depth + 1)); return; }
  if (typeof v !== "object") return;
  for (const [k, x] of Object.entries(v)) {
    if (typeof x === "string") { if (KEYS.has(k) && x.trim()) { DATA_VALUES.add(x.trim().replace(/\s+/g, " ")); if (k === "last_name" && v.first_name) DATA_VALUES.add(`${x} ${v.first_name}`).add(`${v.first_name} ${x}`); } }
    else if (x && typeof x === "object") registerData(x, depth + 1);
  }
}
